export const enUSHouseholdItems = {
  assigneeLabel: 'Assignee: ',
  dueLabel: 'Due: ',
  edit: 'Edit',
  delete: 'Delete',
  stateOpen: 'Open',
  stateDone: 'Done',
  hasPictureLabel: 'Has a picture',
  typeListItem: 'List item',
  typeChore: 'Chore',
  typeTask: 'Task',
  toastCreated: 'Item created',
  toastUpdated: 'Item updated',
  toastDeleted: 'Item deleted',
  toastToggled: 'Item updated',
  toastCreatedError: 'Failed to create item',
  toastUpdatedError: 'Failed to update item',
  toastDeletedError: 'Failed to delete item',
  toastToggledError: 'Failed to update item',
} as const;
